import React from 'react';
import {connect} from 'react-redux';
import UI from 'editor-ui-lib';
import Wix from 'Wix';
import { FormattedMessage } from 'react-intl';
import { injectIntl } from 'react-intl';
import parameters from "../../../../../config/parameters";
import './design.scss';

class Design extends React.Component {

    constructor(props) {
        super(props);  

        this.renderFolderDesign = this.renderFolderDesign.bind(this);
        this.renderFileDesign = this.renderFileDesign.bind(this);
        this.renderColorPickerSlider = this.renderColorPickerSlider.bind(this);
        this.renderColorPickerSliderHover = this.renderColorPickerSliderHover.bind(this);
        this.renderSectionDividerLabeled = this.renderSectionDividerLabeled.bind(this);
    }

    renderColorPickerSlider(title) {
        return (
            <UI.colorPickerSlider 
                title={title || this.props.intl.formatMessage({id: 'settings.design.backgroudColorOpacity'})} 
                wix-param="background" 
                startWithColor="color-1" 
                startWithOpacity={0}>
            </UI.colorPickerSlider>
        )
    }

    renderCornerRadiusSlider() {
        return (
            <UI.slider
                title={this.props.intl.formatMessage({id: 'settings.design.BackgroudCornerRadius'})}
                wix-param="cornerRadius"
                min={0}
                max={10}
                units="px"
                step={1}
                defaultValue={0}>
            </UI.slider>
        )
    }

    renderBorderWidthSlider() {
        return (
            <UI.slider
                title={this.props.intl.formatMessage({id: 'settings.design.BorderWidth'})}
                wix-param="borderWidth"
                min={0}
                max={20}
                units="px"
                step={1}
                defaultValue={0}>
            </UI.slider>
        )
    }

    renderColorPickerSliderHover(text) {
        return (
            <UI.colorPickerSlider 
                title={text}
                wix-param="hoverColor" 
                startWithColor="color-5" 
                startWithOpacity={0.02}>
            </UI.colorPickerSlider>
        )
    }

    renderSectionDividerLabeled(text) {
        return (
            <div>
                <hr className="divider-long"/>
                <UI.sectionDividerLabeled label={text}/>
                <hr className="divider-long"/>
            </div>
        )
    }

    renderFolderList() {
        return(
            <div > 
            <div className='text-and-divider'> 
                {this.renderSectionDividerLabeled(<FormattedMessage id="settings.design.textDivider"/>)}
               <UI.fontAndColorPicker title={this.props.intl.formatMessage({id: 'settings.design.selectedFolderName'})}
                       wix-param-font="navigationFont" 
                       wix-param-color="navigationColor"
                       fontMinSize="16" 
                       fontMaxSize="24"
                       startWithSize="16"
                       startWithColor="color-5"
                       startWithTheme="font_8" 
                       hideStyle="true"	
               > 
               </UI.fontAndColorPicker>
                <hr className="divider-long"/>
                  {/* ////////// */}
                  <UI.fontAndColorPicker 
                       title={this.props.intl.formatMessage({id: 'settings.design.listItemsText'})} 
                       wix-param-font="listItemFont" 
                       wix-param-color="listItemColor"  
                       fontMinSize="12" 
                       fontMaxSize="20"
                       startWithSize="16"
                       startWithColor="color-5"
                       startWithTheme="font_8" 
                       hideStyle="true"	
               > 
               </UI.fontAndColorPicker>
               <hr className="divider-long"/>
                <div className="divider-line-color"> 
                <UI.colorPickerInput 
                    title="Divider lines color" 
                    wix-param="dividerTopColor" 
                    startWithColor="color-5">
                </UI.colorPickerInput>
                </div>  
                <hr className="divider-long"/>
                <UI.slider
                    title={this.props.intl.formatMessage({id: 'settings.design.dividerLinesWidth'})}
                    wix-param="dividerTopWidth"	
                    min={1}
                    max={10}
                    units="px"
                    defaultValue={1}
                    onChange="(newVal)=> this.props.onUpdate('layout_spacing', newVal)">
                </UI.slider>
            </div> 
              <div className="hover-and-bg">
                {this.renderSectionDividerLabeled(<FormattedMessage id="settings.design.hoverBackgrounTitle"/>)}
                {/* {this.renderColorPickerSliderHover("Hover color & opacity")} */}
                <UI.colorPickerInput 
                    title={"Hover color"}
                    wix-param="hoverColor" 
                    startWithColor="color-3">
                </UI.colorPickerInput>
                <hr className="divider-long"/>
                {this.renderColorPickerSlider()} 
                </div>       
            </div>
        )
    }

    renderFolderDesign() {
       
        return (
            this.props.select_layout === 2 ?
                this.renderFolderList()  :
                /////////////////renderFolderTUHMBNAIL
            <div > 
            <div className='text-and-divider'> 
                
                {this.renderSectionDividerLabeled(<FormattedMessage id="settings.design.textDividers"/>)}
               <UI.fontAndColorPicker 
                       title={this.props.intl.formatMessage({id: 'settings.design.selectedFolderName'})} 
                       wix-param-font="navigationFont" 
                       wix-param-color="navigationColor"
                       fontMinSize="16" 
                       fontMaxSize="24"
                       startWithSize="16"
                       startWithColor="color-5"
                       startWithTheme="font_8" 
                       hideStyle="true"	
               > 
               </UI.fontAndColorPicker>
                <hr className="divider-long"/>
                  {/* ////////// */}
                  <UI.fontAndColorPicker 
                       title={this.props.intl.formatMessage({id: 'settings.design.listItemsText'})} 
                       wix-param-font="listItemFont" 
                       wix-param-color="listItemColor"  
                       fontMinSize="12" 
                       fontMaxSize="20"
                       startWithSize="14"
                       startWithColor="color-5"
                       startWithTheme="font_8" 
                       hideStyle="true"	
               > 
               </UI.fontAndColorPicker>
               <hr className="divider-long"/>
                {/* ///////////// */}
                <div className="divider-line-color"> 
                <UI.colorPickerInput 
                    title={this.props.intl.formatMessage({id: 'settings.design.dividerLineColor'})}
                    wix-param="dividerTopColor" 
                    startWithColor="color-5">
                </UI.colorPickerInput>
                </div>  
                <hr className="divider-long"/>
                <UI.slider
                    title={this.props.intl.formatMessage({id: 'settings.design.dividerLineWidth'})}
                    wix-param="dividerTopWidth"	
                    min={1}
                    max={10}
                    defaultValue={1}
                    onChange="(newVal)=>this.props.onUpdate('layout_spacing', newVal)">
                </UI.slider>
            </div> 
              <div className="hover-and-bg">
                {this.renderSectionDividerLabeled(<FormattedMessage id="settings.design.hoverBackgrounTitle"/>)}
                {this.renderColorPickerSliderHover(<FormattedMessage id="settings.design.hoverColorOpacity"/>)}
                <hr className="divider-long"/>
                {this.renderColorPickerSlider()} 
                </div>       
            </div>
            /////////////////ENDrenderFolderTUHMBNAIL
        )
    }

    renderFileDesign() {
        return (
            <div className='text-and-divider'> 
                {this.renderSectionDividerLabeled(<FormattedMessage id="settings.tab.Design"/>)}
                <div className="hover-and-bg">
                    {this.renderBorderWidthSlider()} 
                </div>  
                <div className="hover-and-bg">
                    {this.renderCornerRadiusSlider()} 
                </div>  
                <div className="hover-and-bg">
                    {this.renderColorPickerSlider()} 
                </div>  
            </div>
        )
 }
 
    render() {
        if(this.props.dataPublic && this.props.dataPublic.activeFileId) {
            return this.props.dataPublic.mimeType !== parameters['TYPE_FOLDER'] ? 
                        this.renderFileDesign() : this.renderFolderDesign()
        } 

        return this.renderFileDesign();
    }
}

const mapStateToProps = state => ({
    select_layout: state.userConnectReducer.select_layout,
    layout_file: state.userConnectReducer.layout_file,
    dataPublic: state.dataPublicReducer.dataPublic,
});

export default injectIntl(connect(mapStateToProps)(Design));



// WEBPACK FOOTER //
// ./src/settings/Containers/gdUnitControlPanel/modules/design/design.js